export default function PageWrapper({ children }) {
  return (
    <>
      <div className={'bidder-wrapper'}>{children}</div>
    </>
  );
}
